import React from 'react';
import PropTypes from 'prop-types';

const TurnLeftIcon = ({
  
style = {},
  fill = 'grey',
  width = '100%',
  height = '100%',
  className = '',
  viewBox = '0 0 150 96',
}) => (
  <svg
    fill={fill}
    width={width}
    style={style}
    height={height}
    viewBox={viewBox}
    xmlns="http://www.w3.org/2000/svg"
    className={`svg-icon ${className || ''}`}
    xmlnsXlink="http://www.w3.org/1999/xlink"
  >
    <path
      d="M102.467 57.5222L102.28 34.7715L71.9803 65.3199L102.779 95.3656L102.59 72.3813C130.359 66.8857 150 53.3397 150 37.5C150 16.7893 116.421 0 75 0C33.5786 0 0 16.7893 0 37.5C0 53.4516 19.9196 67.0769 48 72.4965V57.6108C27.2846 53.7255 13 45.5085 13 36C13 22.7452 40.7583 12 75 12C109.242 12 137 22.7452 137 36C137 45.4368 122.93 53.6016 102.467 57.5222Z"/>
      </svg>
);

TurnLeftIcon.propTypes = {
  style: PropTypes.object,
  fill: PropTypes.string,
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string,
  viewBox: PropTypes.string,
};

export default TurnLeftIcon;
